
import { RouteState } from '@circuitry-ai/doc-data';
import { AuditLogsAgGridWrapper, ANALYST_AUDIT_LOG_STATIC_FILTERS, CustomTabs, PageHeader } from '@circuitry-ai/doc-ui';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { AnalystTabs } from './analystBoard';
import AnalyticsList from './analyticsList';
import { Key, useState } from 'react';
import { useTranslation } from 'react-i18next';
import AnalystHistory from './analysthistory';

/* eslint-disable-next-line */
export interface AnalystpageProps { }

enum AnalystPageTabs {
  ANALYST_LIST = 'list',
  ANALYST_HISTORY = 'analyst-history',
  AUDIT_LOGS = 'audit-logs',
}

export function Analystpage(props: AnalystpageProps) {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const analystPageTabs = [
    { key: AnalystPageTabs.ANALYST_LIST, title: t('All Analysts'), id: 'all-analyst-tab' },
    { key: AnalystPageTabs.ANALYST_HISTORY, title: t('Analyst History'), id: 'analyst-history-tab' },
    { key: AnalystPageTabs.AUDIT_LOGS, title: t('Audit Logs'), id: 'analyst-audit-logs-tab' },
  ];

  const [searchParams] = useSearchParams();
  const tabValue = searchParams.get('tab') ?? AnalystPageTabs.ANALYST_LIST;
  const [currentTab, setCurrentTab] = useState<string>(tabValue);

  const onTabChange = (tab: Key) => {
    setCurrentTab(tab as string);
  };

  const renderSelectedTab = () => {
    switch (currentTab) {
      case AnalystPageTabs.ANALYST_LIST:
        return <AnalyticsList />;
      case AnalystPageTabs.ANALYST_HISTORY:
        return <AnalystHistory />;
      case AnalystPageTabs.AUDIT_LOGS:
        return (
          <div className="pt-4 px-3">
            <AuditLogsAgGridWrapper staticFilters={ANALYST_AUDIT_LOG_STATIC_FILTERS} />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className='flex flex-col h-full min-h-0'>
      <PageHeader
        heading="AInalysts"
        description={'View all your AInalysts reports at one place.'}
        showCreateButton={currentTab === AnalystPageTabs.ANALYST_LIST}
        createButtonText={'Create Analyst'}
        entityType="analyst"
        onCreateButtonClick={() => navigate(`/analytics/${RouteState.CREATE}?tab=${AnalystTabs.CONFIGURATION}`)}
      />
      <div className="advisor-tab-list px-5">
        <CustomTabs
          tabs={analystPageTabs}
          selectedKey={currentTab}
          onTabChange={onTabChange}
        />
      </div>
      <div className="flex-1 min-h-0 overflow-y-auto">{renderSelectedTab()}</div>
    </div>
  );
}

export default Analystpage;
